/** Requirements gate copy (keep aligned with server/utils/oktaTabAccess.js REQUIREMENTS_GATE). */
export const REQUIREMENTS_GATE_BY_CONTEXT = {
  Users:
    "To manage users, I need your Okta Org URL and an API token with User/Org administration permissions (typically Super Administrator or Org Administrator).",
  Groups:
    "To manage groups, I need your Okta Org URL and an API token with Group or Organization administration permissions (e.g., Group Membership Administrator, Org Administrator, or Super Administrator).",
  "Profile Editor":
    "To edit profiles and mappings, I need your Okta Org URL and an API token with Organization or Super Administrator permissions.",
  OIDC:
    "To manage OIDC applications, I need your Okta Org URL and an API token with Application Administrator, Org Administrator, or Super Administrator permissions.",
  SAML:
    "To manage SAML applications, I need your Okta Org URL and an API token with Application Administrator, Org Administrator, or Super Administrator permissions.",
  Apps:
    "To manage API services / OAuth clients, I need your Okta Org URL and an API token with Application Administrator, Org Administrator, or Super Administrator permissions.",
  Authenticators:
    "To manage authenticators, I need your Okta Org URL and an API token with Organization or Super Administrator permissions.",
  "Authorization Servers":
    "To manage authorization servers and scopes, I need your Okta Org URL and an API token with API Access Management Administrator, Org Administrator, or Super Administrator permissions.",
  Policies:
    "To manage security policies, I need your Okta Org URL and an API token with Organization or Super Administrator permissions.",
};

export function getRequirementsGateForContext(context) {
  const c = String(context || "Users").trim();
  return REQUIREMENTS_GATE_BY_CONTEXT[c] || REQUIREMENTS_GATE_BY_CONTEXT.Users;
}
